import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET } from '@angular/router';
import 'rxjs/add/operator/filter';
import { ProductoService } from '../../../services/producto/producto.service';
import { CategoriaService } from '../../../services/categoria/categoria.service';

interface IBreadcrumb {
  label: string;
  url: string;
  level: number;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styles: []
})
export class BreadcrumbComponent implements OnInit, OnChanges {
  @Input() tipoContenido: string;
  @Input() categoriaPadre: any;
  @Input() categoriaHija: any;
  public breadcrumbs: IBreadcrumb[];

  constructor(
    private _productoService: ProductoService,
    private _categoriaService: CategoriaService,
    private router: Router
  ) {
    this.breadcrumbs = [];
  }

  ngOnInit() {
    // subscribe to the NavigationEnd event
    this.categoriaHija = null;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.reloadBreadcrumbs();
      }
    });
    this.buildBreadcrumbs();
  }

  ngOnChanges() {
    this.reloadBreadcrumbs();
  }

  reloadBreadcrumbs() {
    if (typeof this.tipoContenido !== 'undefined') {
      if (this.tipoContenido === 'cat') {
        this.breadcrumbs[0] = {label: this.categoriaPadre.nombre, url: this.categoriaPadre.id + '/0', level: 1};
        if (typeof this.categoriaHija !== 'undefined'){
          this.breadcrumbs[1] = {label: this.categoriaHija.nombre, url: this.categoriaPadre.id + '/' + this.categoriaHija.id, level: 1};
        } else {
          this.breadcrumbs[1] = {label: 'Todos', url: this.categoriaPadre.id + '/0', level: 1};
        }
      } else {
        if (this.categoriaHija && this.categoriaHija.hasOwnProperty('categoria')) {
          this.breadcrumbs[0] = {label: this.categoriaHija.categoria.nombre, url: this.categoriaHija.categoria.id + '/0', level: 1};
        }
      }
    }
  }

  buildBreadcrumbs () {
    this._productoService.categoriaWasLoaded.subscribe((categorias: any) => {
      const categoriaProducto = categorias[0];
      this.breadcrumbs[0] = {label: categoriaProducto.nombre, url: categoriaProducto.categoriaId + '/' + categoriaProducto.id, level: 1};
      this.breadcrumbs[1] = {label: categoriaProducto.nombre, url: categoriaProducto.categoriaId + '/' + categoriaProducto.id, level: 1};
    });
    this._categoriaService.categoriaWasLoaded.subscribe((categorias: any) => {
      this.breadcrumbs[0] = {label: categorias.nombre, url: categorias.id + '/0', level: 1};
    });
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/utils/breadcrumb/breadcrumb.component.ts